import allColors from "./color";
import { fontFamily } from "@utils/styles";

const colors = {
  ...allColors,
};

const fonts = {
  ...fontFamily,
};

export { colors, fonts };
